import { initializeApp } from 'firebase/app';
import { getAuth, signInWithPhoneNumber, RecaptchaVerifier } from 'firebase/auth';

const firebaseConfig = {
  apiKey: 'AIzaSyCR-29vNp78PvYWPjiHgvwIJI_n6e0a4n8',
  authDomain: 'drcloud-1ee63.firebaseapp.com',
  projectId: 'drcloud-1ee63',
  storageBucket: 'drcloud-1ee63.firebasestorage.app',
  messagingSenderId: '739934592992',
  appId: '1:739934592992:web:dd7063b599fd9488391585',
  measurementId: 'G-72GM4X0BPJ'
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

// Set language code
auth.languageCode = 'vi';

// Global variable to track RecaptchaVerifier instance
let recaptchaVerifier = null;

const getRecaptchaVerifier = () => {
  if (!recaptchaVerifier) {
    try {
      // Ensure the recaptcha container exists
      const container = document.getElementById('recaptcha-container');
      if (!container) {
        console.error('Recaptcha container not found');
        return null;
      }

      // For Firebase v9+, the RecaptchaVerifier constructor takes auth as first parameter
      recaptchaVerifier = new RecaptchaVerifier(auth, 'recaptcha-container', {
        size: 'invisible',
        callback: (response) => {
          console.log('reCAPTCHA solved');
        },
        'expired-callback': () => {
          console.log('reCAPTCHA expired');
          if (recaptchaVerifier) {
            recaptchaVerifier.clear();
            recaptchaVerifier = null;
          }
        }
      });
      console.log('RecaptchaVerifier created successfully');
    } catch (error) {
      console.error('Error creating RecaptchaVerifier:', error);
      return null;
    }
  }
  return recaptchaVerifier;
};

const signUpWithFirebase = async (phoneNumber) => {
  try {
    console.log('Starting Firebase phone authentication for:', phoneNumber);

    const appVerifier = getRecaptchaVerifier();
    if (!appVerifier) {
      throw new Error('Failed to initialize RecaptchaVerifier');
    }

    const confirmationResult = await signInWithPhoneNumber(auth, phoneNumber, appVerifier);
    console.log('Phone sign-in successful', confirmationResult);

    return { confirmationResult };
  } catch (error) {
    console.error('Firebase signUp error details:', {
      code: error.code,
      message: error.message,
      stack: error.stack
    });

    // reset the reCAPTCHA so the user can try again
    if (recaptchaVerifier) {
      recaptchaVerifier.clear();
      recaptchaVerifier = null;
    }

    return { errorCode: error.code };
  }
};

const confirmOtp = async (confirmationResult, confirmationCode) => {
  try {
    await confirmationResult.confirm(confirmationCode);
    const token = await auth.currentUser.getIdToken();

    return { token };
  } catch (error) {
    console.error('OTP confirmation error:', error);
    return { errorCode: error.code };
  }
};

export { auth, signUpWithFirebase, confirmOtp };
